import { useNavigate } from "react-router-dom";

import {
  APP_API_BASE_URL,
  LOCALHOST,
  REDIRECT_TO_SAME_DOMAIN_AFTER_LOGIN
} from "@/data_source/constants/env";
import { ErrorNotificationStore } from "@/stores/error-store";

export function useAppNavigator() {
  const navigator = useNavigate();
  return (url: string, replace = false, state?: unknown): void => {
    ErrorNotificationStore.getInstance().add(null);
    if (replace) {
      navigator(url, { replace: true, state });
    } else {
      navigator(url, { replace: false, state });
    }
  };
}
export function useGoBack(): () => void {
  const navigator = useNavigate();
  return () => {
    navigator(-2);
  };
}
export function redirect(location: Location) {
  return (baseUrl: string) =>
    (url: string): void => {
      location.href = `${baseUrl}/${url}`;
    };
}

export function resolveAppRedirect(
  path: string,
  host?: { domain: string } | null
): string {
  if (LOCALHOST || REDIRECT_TO_SAME_DOMAIN_AFTER_LOGIN || !host?.domain) {
    return path;
  }
  return `https://${host.domain}${path}`;
}

export function redirectToPage(
  path: string,
  host?: { domain: string } | null,
  navigate?: (route: string) => void
): void {
  const route = resolveAppRedirect(path, host);
  if (route === path) {
    return navigate?.(path);
  }
  window.location.href = route;
}
export function redirectToBackendApp(location: Location) {
  return (url: string): void => {
    const formattedURL = url.match(RegExp("^/", "i")) ? url.slice(1) : url;
    location.href = `${APP_API_BASE_URL}/${formattedURL}`;
  };
}
export function openInNewTab(location: Location) {
  return (url: string, origin?: string): void => {
    window.open(`${origin ?? location.origin}${url}`);
  };
}
